import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-thick-right': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.606 11.278l-8.8-8.771a1 1 0 0 0-1.706.708V8.24a.25.25 0 0 1-.25.25H1.1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11.75a.25.25 0 0 1 .25.25v5.043a1 1 0 0 0 1.707.707l8.8-8.8a1 1 0 0 0 0-1.416z"/>`,
    },
});
